import { render } from "./CourtesyView.vue?vue&type=template&id=2cb6df3e&scoped=true"
import script from "./CourtesyView.vue?vue&type=script&lang=js"
export * from "./CourtesyView.vue?vue&type=script&lang=js"

import "./CourtesyView.vue?vue&type=style&index=0&id=2cb6df3e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb6df3e"]])

export default __exports__